import { baseSpacer, breakpoints, doubleSpacer, halfSpacer, quadrupleSpacer } from '@styles/size';
import styled from 'styled-components';

const PageContainer = styled.div`
  position: relative;
  margin-right: auto;
  margin-left: auto;
  padding-right: ${halfSpacer};
  padding-left: ${halfSpacer};
  width: 100%;
  max-width: ${breakpoints.xl};
  ${(props: { withVerticalPadding?: boolean }) =>
    props.withVerticalPadding && `padding-top: ${doubleSpacer};`}

  @media only screen and (min-width: ${breakpoints.sm}) {
    padding-right: ${baseSpacer};
    padding-left: ${baseSpacer};
    ${(props: { withVerticalPadding?: boolean }) =>
      props.withVerticalPadding && `padding-top: ${quadrupleSpacer};`}
  }
`;

PageContainer.displayName = 'PageContainer';

export default PageContainer;
